/** Scrollbar observers are needed after mount, not during theme bootstrap. */
export function installDeferredScrollbarVisibility(
  load = () => import('./scrollbar-visibility'),
) {
  let active = true;
  let cleanup: (() => void) | undefined;
  void load().then(module => {
    if (active) cleanup = module.installScrollbarVisibility();
  }).catch(error => console.error('Scrollbar visibility could not be initialized', error));
  return () => { active = false; cleanup?.(); };
}
